//import { ValidationRules } from 'aurelia-validation';
//export class RegExpValidationRule extends ValidationRule {
//    constructor(regExp, errorMessage) {
//        super(
//            regExp,
//            (newValue, threshold) => {
//                return true/*your RegExp check should return true/false here*/;
//            },
//            (newValue, threshold) => {
//                return errorMessage;
//            }
//        );
//    }
//}